/* istanbul ignore file */
import { Component, memo } from 'react';
import PropTypes from 'prop-types';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-console
    console.error('ERROR', error, errorInfo);
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    // console.log("error", children);
    return hasError ? <h1>Oops something went wrong!</h1> : children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default memo(ErrorBoundary);
